<script>
const DEFAULT_LAYOUT = "DefaultLayout";

import DefaultLayout from "@/layouts/DefaultLayout.vue";
import LandingPageLayout from "@/layouts/LandingPageLayout.vue";
import MinimalLayout from "@/layouts/MinimalLayout.vue";
import VocabClassQuizLayout from "@/layouts/VocabClassQuizLayout.vue";
import VocabQuizLayout from "@/layouts/VocabQuizLayout.vue";

export default {
  name: "AppLayout",
  components: {
    DefaultLayout,
    MinimalLayout,
    VocabClassQuizLayout,
    VocabQuizLayout,
    LandingPageLayout
  },
  computed: {
    layout() {
      return this.$route?.meta.layout || DEFAULT_LAYOUT;
    }
  }
};
</script>

<template>
  <Component :is="layout">
    <slot />
  </Component>
</template>
